export const BASKET_SYNC_REMOVAL_NOTIFICATION_KEY = 'basket-sync'

export const REMOVAL_TOAST_DEBOUNCE_MS = 500

export const getRemovalToastDescription = count => {
  if (count <= 0) return ''
  if (count === 1) return 'An item was removed'
  return `${count} items were removed`
}

/**
 * Batches rapid basket removals into a single toast after debounceMs.
 */
export const createDebouncedRemovalNotifier = ({
  showNotification,
  debounceMs = REMOVAL_TOAST_DEBOUNCE_MS,
  setTimeoutFn = setTimeout,
  clearTimeoutFn = clearTimeout,
} = {}) => {
  let pendingCount = 0
  let timeoutId = null

  const flush = () => {
    const count = pendingCount
    pendingCount = 0
    timeoutId = null
    if (count > 0) {
      showNotification(count)
    }
  }

  const queueRemoval = () => {
    pendingCount += 1
    if (timeoutId !== null) {
      clearTimeoutFn(timeoutId)
    }
    timeoutId = setTimeoutFn(flush, debounceMs)
  }

  const cancelPending = () => {
    if (timeoutId !== null) {
      clearTimeoutFn(timeoutId)
      timeoutId = null
    }
    pendingCount = 0
  }

  return { queueRemoval, cancelPending }
}
